"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcButton_1 = __importDefault(require("../button/AcButton"));
var AcDocumentViewer_1 = __importDefault(require("../pdf/AcDocumentViewer"));
var AcFilePreviewDialog = function (props) {
    var show = props.show, handleCancel = props.handleCancel, handleSubmit = props.handleSubmit, onHide = props.onHide, file = props.file;
    return (react_1.default.createElement(react_bootstrap_1.Modal, { bsPrefix: 'aperza-app-modal', dialogClassName: 'aperza-app-dialog', backdropClassName: 'aperza-app-backdrop', 
        //dialogClassName="child-bg-transparent"
        //backdropClassName="bg-dark opacity-1"
        size: "lg", show: show, onHide: handleCancel },
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Container, { fluid: true },
                react_1.default.createElement(AcDocumentViewer_1.default, { pdfSource: file, multiPage: false }),
                react_1.default.createElement("div", { className: "fixed-bottom text-right", style: { bottom: '60px', right: '40px' } },
                    react_1.default.createElement(AcButton_1.default, { size: "xxl", variant: "cloudLink", className: "rounded-lg", onClick: handleSubmit },
                        "FAX\u9001\u4FE1\u8A2D\u5B9A\u3078\u9032\u3080 ",
                        react_1.default.createElement("i", { className: "far fa-arrow-right" })))))));
};
exports.AcFilePreviewDialog = AcFilePreviewDialog;
AcFilePreviewDialog.displayName = 'AcFilePreviewDialog';
//# sourceMappingURL=AcFilePreviewDialog.js.map